import React from 'react';
import Index from './pages/Index';
import Create from './pages/Create';
import Edit from './pages/Edit';
import { AppRouteProps } from '~/routes';

export default function GenderRoutes(): readonly AppRouteProps[] {
  const routes: AppRouteProps[] = [
    {path: '/gender', component: Index, isProtected: true, permissions: ['gender_index']},
    {path: '/gender/create', component: Create, isProtected: true, permissions: ['gender_create']},
    {path: '/gender/edit/:id', component: Edit, isProtected: true, permissions: ['gender_edit']},

  ];

  return routes;
}
